// import { extend, configure } from 'vee-validate'
import { extend, configure } from 'vee-validate'
import {
  alpha_num as alphaNum,
  required,
  email
} from 'vee-validate/dist/rules'
import { i18n } from './i18n'

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    // values._field_ = i18n.t(`fields.${field}`)

    return i18n.t(`validations.${values._rule_}`, values)
  }
})
extend('required', required)

extend('email', email)

extend('jobAlertEmail', {
  validate: value => {
    return required.validate(value) && email.validate(value)
  },
  computesRequired: true, // used for required field
  message: () => i18n.t('block_jobalerts_errormsg')
})

extend('reference', {
  ...alphaNum,
  message: () => i18n.t('global_reference_error')
})
